export const getMaxPage = (array, paginationBase) => Math.ceil(array.length / paginationBase);
export const paginate = (array, paginationBase, currentPage) => array.slice((currentPage - 1) * paginationBase, currentPage * paginationBase);
//# sourceMappingURL=pagination.js.map